import React, { useEffect, useState } from "react";

/**
 * Global connectivity banner. Shows a fixed bar when the browser goes offline
 * so users understand why requests are failing, and a brief "back online"
 * confirmation when connectivity returns.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    const goOffline = () => setOnline(false);
    const goOnline = () => {
      setOnline(true);
      setJustReconnected(true);
      setTimeout(() => setJustReconnected(false), 3000);
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (online && !justReconnected) return null;

  const bg = online ? "#059669" : "#b45309";
  const text = online ? "Back online" : "You're offline — some features may not work";

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        background: bg,
        color: "#fff",
        textAlign: "center",
        padding: "8px 16px",
        fontSize: "0.875rem",
        fontWeight: 600,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
      }}
    >
      <i
        className={online ? "fa-solid fa-wifi" : "fa-solid fa-plug-circle-xmark"}
        style={{ marginRight: 8 }}
      />
      {text}
    </div>
  );
}
